<template>
  <div>
    <md-table v-model="users" class="md-table-global-sales">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="">
          <md-icon>account_circle</md-icon>
        </md-table-cell>
        <md-table-cell>{{ item.name }}</md-table-cell>
        <md-table-cell>{{ item.permissionLevel }}</md-table-cell>
        <md-table-cell>
          <span>
            <md-icon class="clickable">edit</md-icon>
            <md-tooltip md-direction="bottom">Edit</md-tooltip>
          </span>
        </md-table-cell>
        <md-table-cell>
          <span>
            <md-icon class="clickable">person_remove</md-icon>
            <md-tooltip md-direction="bottom">Remove</md-tooltip>
          </span>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
export default {
  name: "global-sales-table",
  data() {
    return {
      noticeModal: false,
      selected: [],
      users: [
        {
          name: "Nguyễn Văn A",
          permissionLevel: "Quản lý kho",
          id: 0
        },
        {
          name: "Nguyễn Văn B",
          permissionLevel: "Quản lý đơn hàng",
          id: 1
        }
      ]
    };
  }
};
</script>
